import i18next from 'i18next';

i18next.addResources('es', 'Search', {
  placeholderSearch: 'Escribe tu dirección completa…'
});
